<template>
  <div>
    <l-tables
      ref="externalTable"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input 
            v-model="keyword" 
            @change="search" 
            maxlength="30" 
            :placeholder="$t('organization.external.searchPlaceholder')"
            class="search-item"
          >
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="keyword"
              slot="suffix"
              @click=";(keyword = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
          <a-popover>
            <template slot="content">
              <div class="popover" v-if="selectedProfession.length > 0">
                <span v-for="(item, index) of selectedProfession" :key="item.V1 + item.V2 + item.V3">
                  {{ professionListFind.find(obj => obj.value == item).label }}
                  <span v-if="index !== selectedProfession.length - 1">，</span>
                </span>
              </div>
            </template>
            <a-tree-select
              maxTagCount="1"
              class="search-item"
              :tree-data="professionSearchList"
              tree-checkable
              v-model="selectedProfession"
              :placeholder="$t('organization.external.selectProfession')"
              treeDefaultExpandAll
              @change="handleProfessionChange"
            />
          </a-popover>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('organization.external.create') }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('organization.external.create') }}</a-button>
      </template>
        
      <template slot="importFile">
        <a-button type="primary" @click="uploadVisible = true" class="import" style="margin-right: 10px;background: linear-gradient( 227deg, #72899D 0%, #9BB3C8 100%);">{{ $t('organization.external.batchImport') }}</a-button>
      </template>
      <template #status="{ record }">
        <a-tag :color="record.status == 1 ? 'green' : 'red'">
          {{ record.status == 1 ? $t('organization.external.status.normal') : $t('organization.external.status.disabled') }}
        </a-tag>
      </template>
      <template #type="{ record }">
        {{ record.type == 1 ? $t('organization.external.type.teacher') : $t('organization.external.type.student') }}
      </template>
    </l-tables>

    <upload-modal
      :visible="uploadVisible"
      :title="$t('organization.external.batchImportTitle')"
      @upload="handleUpload"
      @cancel="uploadVisible = false"
      @fileChange="handleFileChange"
      @downloadTemplate="downloadTemplate"
    />
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import UploadModal from '@/components/UploadModal.vue'
import { externalImport } from '@/api/admin'
import { getAdminOrgList } from '@/api/lesson'

export default {
  components: {
    LTables,
    UploadModal
  },
  data() {
    return {
      keyword: undefined,
      uploadVisible: false,
      importFile: null,
      noCreatText: this.$t('organization.external.noExternalUsers'),
      nullImg: require('@/assets/img/studentNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      selectedProfession: [],
      professionSearchList: [],
      searchData: {
        keyword: '',
        type: undefined,
        professionId: ''
      },
      tableConfig: {
        tableName: this.$t('organization.external.title'),
        tableColumns: [
          {
            title: this.$t('organization.external.columns.id'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.schoolName'),
            dataIndex: 'schoolName',
            key: 'schoolName',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.name'),
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.employeeNumber'),
            dataIndex: 'employeeNumber',
            key: 'employeeNumber',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.profession'),
            dataIndex: 'profession',
            key: 'profession',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center'
          },
          {
            title: this.$t('organization.external.columns.operation'),
            dataIndex: 'operate',
            key: 'operate',
            width: 200,
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('organization.external.deleteConfirm.title'),
          content: this.$t('organization.external.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/external_user/list',
          del: '/admin/external_user/delete'
        },
        tableEditRouteNName: 'organizationExternalAdd'
      }
    }
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList]) {
      getList()
    },
    create() {
      this.$router.push({
        name: 'organizationExternalAdd'
      })
    },
    handleFileChange(file) {
      this.importFile = file
    },
    handleUpload() {
      if (!this.importFile) {
        this.$message.error(this.$t('organization.external.uploadRequired'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.importFile)
      
      externalImport(formData).then(res => {
        if (res.code !== 200) return
        this.uploadVisible = false
        this.$message.success(this.$t('organization.external.importSuccess'))
        this.$refs.externalTable.getList()
      })
    },
    downloadTemplate() {
      // window.open('/static/xlsx/外校导入模版.xlsx')
      location.href = '/static/xlsx/外校导入模版.xlsx'
    },
    async getProfessionList() {
      try {
        this.professionListFind = []
        const res = await getAdminOrgList()
        if (res.code === 200) {
          this.professionSearchList = res.data.list.map(college => ({
            value: college.id,
            label: college.name,
            disabled: true,
            children: college.child.map(department => ({
              value: department.id,
              label: department.name,
              disabled: true,
              children: department.child.map(profession => {
                this.professionListFind.push({
                  value: profession.id,
                  label: profession.name
                })
                return {
                  value: profession.id,
                  label: profession.name,
                  isLeaf: true
                }
              })
            }))
          }))
        }
      } catch (error) {
        console.error('获取专业列表失败:', error)
        this.$message.error(this.$t('organization.external.getProfessionListFailed'))
      }
    },
    handleProfessionChange(value) {
      this.searchData.professionId = value
      this.search()
    }
  },
  mounted() {
    this.getProfessionList()
  }
}
</script>

<style lang="less" scoped>
.search-conditions {
  display: flex;
  align-items: center;
  .search-item {
    margin-right: 16px;
    width: 240px;
  }
}
/deep/ .ant-select-selection--multiple {
  border-radius: 20px;
}
</style>
